import React, { FC } from "react";
import classes from "./style/NotificationCard.module.css";
import { StatusObj } from "../../../store/slice/authSliceLogin/authSliceLogin";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { MailOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../../store/reduxHooks";
import { CLEARE_APP_NOTIFICATIONS } from "../../../store/slice/notificationsSlice/notificationsSlice";
import { useDeleteNotificationsMutation } from "../../../store/api/notifications.api";

interface INotificationCard {
  app_id: string | number;
  application?: { title?: string; status?: StatusObj };
  bank?: { title: string; status?: StatusObj };
  isNewMessage?: boolean;
  closeDrawer: () => void;
}

// карточка уведомления
const NotificationCard: FC<INotificationCard> = ({
  app_id,
  application,
  bank,
  isNewMessage,
  closeDrawer,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [deleteNotification] = useDeleteNotificationsMutation();

  const gotToLink = async () => {
    closeDrawer();
    navigate(`/application/${app_id}`);
    await deleteNotification({ app_id });
    dispatch(CLEARE_APP_NOTIFICATIONS({ app_id: app_id }));
  };

  const renderBankNotification = (bank: {
    title: string;
    status?: StatusObj;
  }) => {
    if (bank?.status) {
      return (
        <div className={classes.notificationText}>
          {bank?.title}. Новый статус:{" "}
          <Tag color={bank?.status.color}>{bank?.status.title}</Tag>
        </div>
      );
    } else {
      return (
        <div className={classes.notificationText}>
          Изменение данных банка: {bank?.title}
        </div>
      );
    }
  };

  const renderApplicationNotification = (application: {
    title?: string;
    status?: StatusObj;
  }) => {
    if (application.status) {
      return (
        <div className={classes.notificationText}>
          Изменение статуса заявки:{" "}
          <Tag color={application?.status.color}>
            {application?.status.title}
          </Tag>
        </div>
      );
    } else {
      return (
        <div className={classes.notificationText}>{application.title}.</div>
      );
    }
  };

  return (
    <div className={classes.notificationCard} onClick={gotToLink}>
      <div className={classes.notificationTitle}>
        Изменение в заявке{` №${app_id}`}
      </div>
      {application && renderApplicationNotification(application)}
      {bank && renderBankNotification(bank)}
      {isNewMessage && (
        <div className={classes.notificationMessage}>
          <MailOutlined style={{ color: "#3C79FF", fontSize: "22px" }} />
          <div>Новое сообщение</div>
        </div>
      )}
    </div>
  );
};

export default NotificationCard;
